/**
 * Takes variable number of strings and joins them with the CSS class delimiter.
 *
 * @param {...string} partialClassNames
 * @returns {string} the joined class name
 */
export const joinClassName = function (...partialClassNames) {
    return partialClassNames.join("-");
};
